import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ErrorCode, RecipientsApi, RestApiError, type CreateRecipientRequest, type RecipientResponse } from '@shared/api';

const ERROR_CODES = [ErrorCode.TRP_VAL_008, ErrorCode.TRP_VAL_009, ErrorCode.TRP_VAL_010, ErrorCode.TRP_VAL_011];

const createRecipientEffect = createEffect((request: CreateRecipientRequest) => RecipientsApi.createRecipient(request));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(createRecipientEffect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(createRecipientEffect.pending, (_, data) => data)
  .on(createRecipientEffect.fail, () => false)
  .on(createRecipientEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<{ message: string; errorCode?: ErrorCode } | null>(null)
  // .on(createRecipientEffect, () => null)
  // .on(createRecipientEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(createRecipientEffect.fail, (_, data) => {
    if (RestApiError.isRestApiError(data.error) && data.error.data.errorCode) {
      if (ERROR_CODES.includes(data.error.data.errorCode)) return { errorCode: data.error.data.errorCode, message: data.error.data.message };
      return { message: data.error.message };
    }
    return { message: 'Something went wrong while creating Recipient. Please try again.' };
  })
  .on(createRecipientEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error?.errorCode ? null : error?.message));

export const $recipientCreateStore = {
  events: {
    createRecipient: createRecipientEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
